<template>
  <div v-show="hasItems">
    <Carousel
      v-if="isCarousel && items.length"
      :items="items"
      :height="180"
      :see-more-enabled="true"
      :see-more-link="$trailingSlash(localePath(seeMoreLink))"
      @item-click="vectorClick"
    >
      <template #overlay="slotProps">
        <NormalVectorOverlay :data="slotProps.data" />
      </template>
    </Carousel>
    <SearchGrid v-else :slice="slice" :items="items" @item-click="vectorClick"></SearchGrid>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Carousel from '@/components/Common/Carousel';
import NormalVectorOverlay from '@/components/Vectors/NormalVectorOverlay';

const SearchGrid = () => import('@/components/Prismic/Landings/Slices/SearchGrid.vue');

export default {
  components: {
    Carousel,
    SearchGrid,
    NormalVectorOverlay
  },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      criteria: '',
      dimension: '',
      perPage: '',
      sort: '',
      experience: '',
      enableSort: false,
      seeMoreLink: '',
      isCarousel: false
    };
  },
  computed: {
    ...mapGetters('search', ['getMultipleSearchResult']),
    items() {
      return this.getMultipleSearchResult(`${this.dimension}_${this.criteria}`);
    },
    hasItems() {
      return this.items?.length;
    }
  },
  async created() {
    const { primary } = this.slice;

    const criteriaInput = primary.criteria[0]?.text;
    const itemsLimitInput = primary.items_limit;
    this.criteria = criteriaInput ? criteriaInput.replace(/-/g, ' ') : '';
    this.dimension = primary.dimension;
    this.perPage = itemsLimitInput > 0 ? itemsLimitInput : 20;

    this.sort = primary.sort;
    this.experience = primary.sort_experience;
    this.enableSort = primary.enable_sort;
    this.isCarousel = primary.show_as_carousel;
    this.seeMoreLink = primary?.see_more_link[0] ? primary?.see_more_link[0].text : '';
    await this.$store.dispatch('search/MAKE_SIMPLE_SEARCH', {
      criteria: this.criteria,
      dimension: this.dimension,
      perPage: this.perPage,
      experience: this.experience,
      sort: this.sort,
      enableSort: this.enableSort
    });
  },
  methods: {
    async vectorClick({ item, shownListing }, e) {
      e.preventDefault();
      this.$bvModal.show('preview-vector-modal');
      await this.$store.dispatch('vectors/OPEN_PREVIEW', { id: item.id, list: shownListing });
    }
  }
};
</script>
